import { render, staticRenderFns } from "./RelationshipChild.vue?vue&type=template&id=19bf716a"
import script from "./RelationshipChild.vue?vue&type=script&lang=js"
export * from "./RelationshipChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports